import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { constant } from "common/constant";
import { getApi } from "common/services/api";
export const getContactList = createAsyncThunk(
  "contactLead/getContactList",
  async ({ page = 1, limit = 10, sortKey, order, searchTerm, fetchAllData = false } = {}, { rejectWithValue }) => {
    try {
      const user = JSON.parse(localStorage.getItem("user"));

      let endpoint;
      if (fetchAllData) {
        endpoint =
          user?.role === "superAdmin"
            ? `api/contact?allData=true`
            : `api/contact?createBy=${user?._id}&allData=true`;
      } else {
        endpoint =
          user?.role === "superAdmin"
            ? `api/contact/?page=${page}&limit=${limit}`
            : `api/contact/?createBy=${user?._id || (() => {
              console.warn("User ID is undefined, using fallback value.");
              return "unknown";
            })()}&page=${page}&limit=${limit}`;
        if (sortKey) {
          const sortParam = order === "desc" ? `-${sortKey}` : sortKey;
          endpoint += `&sort=${sortParam}`;
        }
        if (searchTerm) {
          endpoint += `&search=${encodeURIComponent(searchTerm)}`;
        }
      }

      const result = await getApi(endpoint);
      return result?.data;
    } catch (error) {
      console.error("Error fetching contacts:", error);
      toast.error(constant.somethingWrong);
      return rejectWithValue(error.message || constant.somethingWentWrong);
    }
  }
);

export const getLeadList = createAsyncThunk(
  "contactLead/getLeadList",
  async ({ page = 1, limit = 10, sortKey, order, searchTerm, fetchAllData = false } = {}, { rejectWithValue }) => {
    try {
      const user = JSON.parse(localStorage.getItem("user"));

      let endpoint;
      if (fetchAllData) {
        endpoint =
          user.role === "superAdmin"
            ? `api/lead?allData=true`
            : `api/lead?createBy=${user?._id || (() => {
              console.warn("User ID is undefined, using fallback value.");
              return "unknown";
            })()}&allData=true`;
      } else {
        endpoint =
          user.role === "superAdmin"
            ? `api/lead/?page=${page}&limit=${limit}`
            : `api/lead/?createBy=${user?._id || (() => {
              console.warn("User ID is undefined, using fallback value.");
              return "unknown";
            })()}&page=${page}&limit=${limit}`;
        if (sortKey) {
          const sortParam = order === "desc" ? `-${sortKey}` : sortKey;
          endpoint += `&sort=${sortParam}`;
        }
        if (searchTerm) {
          endpoint += `&search=${encodeURIComponent(searchTerm)}`;
        }
      }

      const result = await getApi(endpoint);
      return result?.data;
    } catch (error) {
      console.error("Error fetching leads:", error);
      toast.error(constant.somethingWrong);
      return rejectWithValue(error.message || constant.somethingWentWrong);
    }
  }
);

const contactLeadSlice = createSlice({
  name: "contactLead",
  initialState: {
    contacts: [],
    leads: [],
    metadata: {},
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getContactList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getContactList.fulfilled, (state, action) => {
        state.loading = false;
        state.contacts = action?.payload?.data;
        state.metadata = action?.payload?.metadata;
      })
      .addCase(getContactList.rejected, (state, action) => {
        state.loading = false;
        state.error = action?.payload;
      })

      .addCase(getLeadList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getLeadList.fulfilled, (state, action) => {
        state.loading = false;
        state.leads = action?.payload?.data;
        state.metadata = action?.payload?.metadata;
      })
      .addCase(getLeadList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default contactLeadSlice.reducer;
